module.exports = __webpack_public_path__ + "static/media/tw.63b04fd0.svg";